export const environment = {
    production: false,
    demo: true,
    maintenance: false,
    name: {
        short: 'dev',
        long: 'dev',
    },
    WebSocket: {
        key: 'ovvyit7lsoaoawpdimcy',
        cluster: 'mt1',
        wsHost: 'websocketserver-e4bb0cb0f8c3.deltablue.io',
        wsPort: 443,
        wssPort: 443,
        forceTLS: true,
        encrypted: true,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
    },
    integrations: {
        keySecret: 'w3DO62KV85U68WgJ',
        webinarKey: 'zDOZ9n6tY1kz6lFNbc8TsGHDffEtZn0w',
        beamer: 'UYnzpRBS27242',
    },
    payments: {
        stripeKey: 'pk_test_K45FsLAqvD754RIG0PKjRDTd',
        weavr: 'apl6rkn0HRcBc+IejpAADA==',
    },
    analytics: {
        google: 'UA-112169318-4',
        mixpanel: '2de0b492c5dfab39cb2a95d19a249b43',
        fullstory: '4HEW5',
    },
    domain: 'deltablue.com',
    tokenName: 'token_msc_staging',
    tokenSessionName: 'token_session',
    refreshTokenName: 'refresh_token_staging',
    envVar: {
        CHAT_URL: 'https://chat.myskillcamp.com.deltablucdn.com',
        CSS_URL: 'https://cdn.myskillcamp.com.deltablucdn.com',
        AUTHENTICATION_API_URL: "https://auth.myskillcamp.com.deltabluecdn.com",
        API_URL: "https://api-upgraded.myskillcamp.com.deltabluecdn.com/api",
        API_STOCKAGE_URL: "https://api-upgraded.myskillcamp.com.deltabluecdn.com/api/stockage/",
        REPORTING_URL: "https://newreportinguat-5c8170cb08ac.deltablue.io/api/v2",
        STUDIO_URL: "https://studio.myskillcamp.com.deltabluecdn.com/",
        PLAYER_URL: "https://player.myskillcamp.com.deltabluecdn.com/",
        APP_URL: "https://api-upgraded.myskillcamp.com.deltabluecdn.com",
        AUTHORIZATION_SERVER_URL: "https://cloud.myskillcamp.com.deltabluecdn.com",
        API_BROADCAST: "https://api-upgraded.myskillcamp.com.deltabluecdn.com"
    },
};
